import { TranslateService } from '@ngx-translate/core';
import { ECheckpointDataType } from 'src/app/models';

const ORDERED: ECheckpointDataType[] = [
  ECheckpointDataType.None,
  ECheckpointDataType.Boolean,
  ECheckpointDataType.Text,
  ECheckpointDataType.LongText,
  ECheckpointDataType.DescriptionText,
  ECheckpointDataType.Numeric,
  ECheckpointDataType.Date,
  ECheckpointDataType.Time,
  ECheckpointDataType.UniqueSelection,
  ECheckpointDataType.MultipleSelection,
  ECheckpointDataType.Photograph,
  ECheckpointDataType.Signature,
  ECheckpointDataType.Sensor,
];

export function checkpointDataTypeSelectItems(tr: TranslateService): { id: number; name: string }[] {
  return ORDERED.map(id => ({
    id,
    name: tr.instant(`enumeration.ECheckpointDataType.${ECheckpointDataType[id]}`),
  }));
}
